import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ChartConfiguration } from 'chart.js';

export interface ChartFullscreenDialogData {
  title: string;
  tooltip?: string;
  chartData: ChartConfiguration<any>['data'];
  chartOptions: ChartConfiguration<any>['options'];
  chartType: string;
}

@Component({
  selector: 'app-chart-fullscreen-dialog',
  templateUrl: './chart-fullscreen-dialog.component.html',
  styleUrls: ['./chart-fullscreen-dialog.component.scss'],
})
export class ChartFullscreenDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ChartFullscreenDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ChartFullscreenDialogData,
  ) {}

  fechar(): void {
    this.dialogRef.close();
  }
}
